import { render } from "./QuestionComponent.vue?vue&type=template&id=38df1009"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/QuestionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38df1009"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38df1009', __exports__)) {
    console.log('reload')
    api.reload('38df1009', __exports__)
  }
  
  module.hot.accept("./QuestionComponent.vue?vue&type=template&id=38df1009", () => {
    console.log('re-render')
    api.rerender('38df1009', render)
  })

}


export default __exports__